import { render, staticRenderFns } from "./SkeletonFilterRawMaterialComponent.vue?vue&type=template&id=233a03a3&scoped=true&"
import script from "./SkeletonFilterRawMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonFilterRawMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonFilterRawMaterialComponent.vue?vue&type=style&index=0&id=233a03a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a03a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSkeletonLoader,VSpacer})
